// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"77aab8e8","821":"890efc2d"}[chunkId] + ".chunk.js";
};